module.exports = __webpack_public_path__ + "static/media/Hero.eabdb676.png";